import { createApp } from 'vue/dist/vue.esm-bundler';
import { VueQueryPlugin } from '@tanstack/vue-query';
import AccordionGroup from './AccordionGroup/AccordionGroup.vue';
import AccordionToggle from './AccordionToggle/AccordionToggle.vue';
import AfterSalesCta from '../components/AfterSalesCta/AfterSalesCta.vue';
import AfterSalesWrapper from '../components/AfterSalesCta/AfterSalesWrapper.vue';
import AirportLookup from '../components/AirportLookup/AirportLookup.vue';
import AmadeusBookingUrl from './AmadeusBookingUrl/AmadeusBookingUrl.vue';
import AmadeusProvider from './AmadeusProvider/AmadeusProvider.vue';
import ArticlesFilter from '../components/SearchFilters/ArticlesFilter.vue';
import BaseModal from './BaseModal/BaseModal.vue';
import BookButton from '../components/BookButton/BookButton.vue';
import BookingWidget from '../components/BookingWidget/BookingWidget.vue';
import BookingTabs from '../components/BookingWidget/BookingTabs.vue';
import BookingWidgetMobile from '../components/BookingWidget/BookingWidgetMobile.vue';
import CabinInput from '../components/CabinInput/CabinInput.vue';
import CarouselBlock from './CarouselBlock/CarouselBlock.vue';
import CheckIn from './CheckIn/CheckIn.vue';
import CounterControl from '../components/CounterControl/CounterControl.vue';
import CopyLink from './CopyLink/CopyLink.vue';
import DealsBlock from './DealsBlock/DealsBlock.vue';
import DealsBlockWrapper from './DealsBlock/DealsBlockWrapper.vue';
import DealsFilters from './FlightDeals/DealsFilters.vue';
import DestinationCta from './DealsBlock/DestinationCta.vue';
import DestinationModalContent from './DealsBlock/DestinationModalContent.vue';
import DropdownSelect from '../components/DropdownSelect/DropdownSelect.vue';
import EconomyMaxBlock from './EconomyMaxBlock/EconomyMaxBlock.vue';
import EpiserverForm from '../components/FormGroup/EpiserverForm.vue';
import FactChecker from './FactChecker/FactChecker.vue';
import FactIndicator from './FactChecker/FactIndicator.vue';
import FilterInput from '../components/FilterInput/FilterInput.vue';
import FlightDeals from './FlightDeals/FlightDeals.vue';
import FlightLandingWidget from '../components/FlightLandingWidget/FlightLandingWidget.vue';
import FlightSchedule from '../components/FlightSchedule/FlightSchedule.vue';
import FlightStatus from './FlightStatus/FlightStatus.vue';
import FlightUpgradeBlock from './FlightUpgradeBlock/FlightUpgradeBlock.vue';
import FooterScrollTop from './FooterScrollTop/FooterScrollTop.vue';
import GeolocationTabs from './GeolocationTabs/GeolocationTabs.vue';
import GlobalSearch from '../components/Search/GlobalSearch.vue';
import HeaderTabs from '../components/HeaderTabs/HeaderTabs.vue';
import HeroSimpleBlock from './HeroSimpleBlock/HeroSimpleBlock.vue';
import HistogramItem from '../components/HistogramItem/HistogramItem.vue';
import IconCta from '../components/AfterSalesCta/IconCta.vue';
import IconPreloader from '../components/IconPreloader/IconPreloader.vue';
import InputField from './InputField/InputField.vue';
import ManageBooking from './ManageBooking/ManageBooking.vue';
import Modal from '../components/Modal/Modal.vue';
import NotificationBanner from './NotificationBanner/NotificationBanner.vue';
import NotificationTicker from './NotificationTicker/NotificationTicker.vue';
import OnceOffModal from './OnceOffModal/OnceOffModal.vue';
import OutdatedBrowserModal from './OutdatedBrowserModal/OutdatedBrowserModal.vue';
import PopOutSearchInput from '../components/PopOutSearchInput/PopOutSearchInput.vue';
import PromoCode from '../components/PromoCode/PromoCode.vue';
import PromotionsTimer from './PromotionsBlock/PromotionsTimer.vue';
import RadioButton from '../components/RadioButton/RadioButton.vue';
import RangeSlider from './RangeSlider/RangeSlider.vue';
import ResourceWrapper from '../components/ResourceWrapper/ResourceWrapper.vue';
import RouteMap from '../components/RouteMap/RouteMap.vue';
import RoutePlanner from '../components/RouteplannerWrapper/route-planner.vue';
import ScrollTo from './ScrollTo/ScrollTo.vue';
import ScrollTop from './ScrollTop/ScrollTop.vue';
import SearchInput from './SearchInput/SearchInput.vue';
import ScrollTable from './ScrollTable/ScrollTable.vue';
import SectionCtaMasonryBlock from './SectionCtaMasonryBlock/SectionCtaMasonryBlock.vue';
import SectionFeaturedContentBlock from './SectionFeaturedContentBlock/SectionFeaturedContentBlock.vue';
import SelectList from './SelectList/SelectList.vue';
import SelectCombobox from '../components/SelectCombobox/SelectCombobox.vue';
import SocialShare from '../components/SocialShare/SocialShare.vue';
import SplideCustom from './SplideCustom/SplideCustom.vue';
import StackingModal from './StackingModal/StackingModal.vue';
import TabList from './TabList/TabList.vue';
import TeamMember from '../components/TeamBlock/TeamMember.vue';
import TimelineBlock from './TimelineBlock/TimelineBlock.vue';
import Tooltip from './Tooltip/Tooltip.vue';
import UserPrefs from './UserPrefs/UserPrefs.vue';
import VideoEmbed from '../components/VideoEmbed/VideoEmbed.vue';
import VisaAndHealth from '../components/VisaAndHealth/VisaAndHealth.vue';
import ViewPdf from '../components/ViewPdf/ViewPdf.vue';
import HorizontalLink from '../components/AfterSalesCta/HorizontalLink.vue';
var main = createApp({})
    .use(VueQueryPlugin)
    .component('AccordionGroup', AccordionGroup)
    .component('AccordionToggle', AccordionToggle)
    .component('AfterSalesCta', AfterSalesCta)
    .component('AfterSalesWrapper', AfterSalesWrapper)
    .component('AirportLookup', AirportLookup)
    .component('AmadeusBookingUrl', AmadeusBookingUrl)
    .component('AmadeusProvider', AmadeusProvider)
    .component('ArticlesFilter', ArticlesFilter)
    .component('BaseModal', BaseModal)
    .component('BookButton', BookButton)
    .component('BookingWidget', BookingWidget)
    .component('BookingTabs', BookingTabs)
    .component('BookingWidgetMobile', BookingWidgetMobile)
    .component('CabinInput', CabinInput)
    .component('CarouselBlock', CarouselBlock)
    .component('CheckIn', CheckIn)
    .component('CounterControl', CounterControl)
    .component('CopyLink', CopyLink)
    .component('DealsBlock', DealsBlock)
    .component('DealsBlockWrapper', DealsBlockWrapper)
    .component('DealsFilters', DealsFilters)
    .component('DestinationCta', DestinationCta)
    .component('DestinationModalContent', DestinationModalContent)
    .component('DropdownSelect', DropdownSelect)
    .component('EconomyMaxBlock', EconomyMaxBlock)
    .component('EpiserverForm', EpiserverForm)
    .component('FactChecker', FactChecker)
    .component('FactIndicator', FactIndicator)
    .component('FilterInput', FilterInput)
    .component('FlightDeals', FlightDeals)
    .component('FlightLandingWidget', FlightLandingWidget)
    .component('FlightSchedule', FlightSchedule)
    .component('FlightStatus', FlightStatus)
    .component('FlightUpgradeBlock', FlightUpgradeBlock)
    .component('FooterScrollTop', FooterScrollTop)
    .component('GeolocationTabs', GeolocationTabs)
    .component('GlobalSearch', GlobalSearch)
    .component('HeaderTabs', HeaderTabs)
    .component('HeroSimpleBlock', HeroSimpleBlock)
    .component('HistogramItem', HistogramItem)
    .component('IconCta', IconCta)
    .component('IconPreloader', IconPreloader)
    .component('InputField', InputField)
    .component('ManageBooking', ManageBooking)
    .component('Modal', Modal)
    .component('NotificationBanner', NotificationBanner)
    .component('NotificationTicker', NotificationTicker)
    .component('OnceOffModal', OnceOffModal)
    .component('OutdatedBrowserModal', OutdatedBrowserModal)
    .component('PopOutSearchInput', PopOutSearchInput)
    .component('PromoCode', PromoCode)
    .component('PromotionsTimer', PromotionsTimer)
    .component('RadioButton', RadioButton)
    .component('RangeSlider', RangeSlider)
    .component('ResourceWrapper', ResourceWrapper)
    .component('RouteMap', RouteMap)
    .component('RoutePlanner', RoutePlanner)
    .component('ScrollTo', ScrollTo)
    .component('ScrollTop', ScrollTop)
    .component('SearchInput', SearchInput)
    .component('ScrollTable', ScrollTable)
    .component('SectionCtaMasonryBlock', SectionCtaMasonryBlock)
    .component('SectionFeaturedContentBlock', SectionFeaturedContentBlock)
    .component('SelectCombobox', SelectCombobox)
    .component('SelectList', SelectList)
    .component('SocialShare', SocialShare)
    .component('SplideCustom', SplideCustom)
    .component('StackingModal', StackingModal)
    .component('TabList', TabList)
    .component('TeamMember', TeamMember)
    .component('TimelineBlock', TimelineBlock)
    .component('Tooltip', Tooltip)
    .component('UserPrefs', UserPrefs)
    .component('VideoEmbed', VideoEmbed)
    .component('ViewPdf', ViewPdf)
    .component('HorizontalLink', HorizontalLink)
    .component('VisaAndHealth', VisaAndHealth);
var tables = document.querySelectorAll('.table');
tables.forEach(function (table) {
    var _a, _b;
    var scrollTable = document.createElement('scroll-table');
    // Move all child nodes of the current table into the <scroll-table> element
    while (table.firstChild) {
        scrollTable.appendChild(table.firstChild);
    }
    // Append the <scroll-table> element back to the original parent of the table
    (_a = table.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(scrollTable, table);
    // Remove the original table
    (_b = table.parentNode) === null || _b === void 0 ? void 0 : _b.removeChild(table);
});
// After wrapping all the tables, you can proceed with the rest of your code
main.mount('#app');
